//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClickOutside from '@/directives/ClickOutside';

const appRoot = document.querySelector('#app-root');

export default {
  name: 'DpTreeViewHeaderContextMenu',
  directives: {
    ClickOutside,
  },
  props: {
    disableRemove: { type: Boolean, default: false },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    options() {
      let opts = [
        { label: 'Reset column width', action: 'reset' },
      ];
      if (!this.disableRemove) {
        opts = [
          ...opts,
          { break: true },
          { label: 'Remove column', action: 'remove' },
        ];
      }
      return opts;
    },
  },
  mounted() {
    if (appRoot) {
      appRoot.appendChild(this.$el);
    }
  },
  beforeDestroy() {
    if (appRoot) {
      appRoot.removeChild(this.$el);
    }
  },
  methods: {
    open(ev) {
      this.visible = true;
      ev.preventDefault();

      // Reposition to cursor pos
      const { clientX, clientY } = ev;
      const x = clientX + 5;
      const y = clientY - 10;

      this.$el.style.left = `${x}px`;
      this.$el.style.top = `${y}px`;
    },
    close() {
      this.visible = false;
    },
    click(option) {
      this.$emit('action', option.action);
      this.visible = false;
    },
  },
};
